import { render } from "./WarehouseDatatableTDWarehouseTitle.vue?vue&type=template&id=6d993370"
import script from "./WarehouseDatatableTDWarehouseTitle.vue?vue&type=script&lang=js"
export * from "./WarehouseDatatableTDWarehouseTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__